import { _filterObject } from '@naturalcycles/js-lib'
import { Assignments, Experiment, LANG } from '@naturalcycles/shared'
import { experimentConfigMap } from '../../constants/experiment.cnst'

export function filterAssignmentsForAllowedLanguages(
  assignments: Assignments,
  lang: LANG,
): Assignments {
  return _filterObject(assignments, experiment => {
    const config = experimentConfigMap[experiment as Experiment]
    if (!config) {
      return true
    }

    const { allowedLanguages } = config
    if (!allowedLanguages) {
      return true
    }

    return allowedLanguages.includes(lang)
  })
}
